// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yxMx32 {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  flex-wrap: wrap;
  justify-content: space-between;
}

.N8RqI8 {
  width: 236px;
  flex-shrink: 0;
}

.gLYtFK {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  flex-wrap: wrap;
  justify-content: flex-end;
}

.KSfW29 {
  flex: 1;
  justify-content: flex-start;
}

.M5a5i5 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryFilter/BeneficiaryFilter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".filtersContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.searchContainer {\n  width: 236px;\n  flex-shrink: 0;\n}\n\n.filtersContent {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.filtersContentStart {\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.trailingActions {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtersContainer": `yxMx32`,
	"searchContainer": `N8RqI8`,
	"filtersContent": `gLYtFK`,
	"filtersContentStart": `KSfW29`,
	"trailingActions": `M5a5i5`
};
module.exports = ___CSS_LOADER_EXPORT___;
